<template>
  <div class="policy">
    <h2>NothingDB商务平台服务条款</h2>
    <h3>介绍</h3>
    <p>
      以下是服务条款。本条款和条件适用于您使用本网站；通过使用本网站，您完全接受这些条款和条件。如果您不同意这些条款和条件或这些条款和条件的任何部分，您不得使用本网站。通过使用本网站并同意这些条款和条件，即表示您同意我们网络平台根据我们隐私政策的条款使用cookie。
    </p>
    <h3>使用网站的许可</h3>
    <p>
      根据以下许可，保留所有这些知识产权。我们特此授予您一项非排他性的、不可转让的订阅，用于在本期限内使用本服务，仅供您根据订单錶中描述的使用参数进行内部使用，以订购此类订阅，并受本服务条款约束。
    </p>
    <h3>设定帐户</h3>
    <p>
      您必须提供准确和完整的资讯，包括您的合法全名、工作电子邮寄地址以及帐户注册过程中要求的任何其他资讯，以获取帐户和使用服务，并在更改时更新此资讯。你必须是一个人，建立一个帐户，并使用该服务。帐户不能由“机器人”或其他自动方法创建的。您有责任确保您的帐户和密码安全，并且还负责使用您的帐户或密码进行的所有活动。我们对您未能遵守此义务或未经授权使用您的帐户而导致的任何损失或损害概不负责。未经允许，您不得使用他人的帐户。您必须立即通知我们任何违反安全或未经授权使用您的帐户。
    </p>
    <h3>取消和终止</h3>
    <p>您全权负责正确关闭您的帐户。</p>
    <p>您可以随时通过电邮我们关闭您的帐户。</p>
    <h3>可接受的使用</h3>
    <p>
      您不得以任何管道使用本网站，导致或可能导致网站损坏或网站的可用性或可获得性受损；或以任何非法、非法、欺诈或有害的管道，或与任何非法、非法、欺诈或有害的目的或活动有关。您不得使用本网站複制、存储、託管、传输、发送、使用、发佈或分发由任何间谍软体、电脑病毒、特洛伊木马、蠕虫、击键记录器、rootkit或其他恶意电脑软体组成（或连结）的任何资料。未经我们的明确书面同意，您不得在本网站上或与之相关的任何系统或自动化的数据收集活动（包括但不限于抓取、资料挖掘、数据选取和数据收集）。您不得使用本网站传送或发送未经请求的商业通讯。
    </p>
    <h3>受限访问</h3>
    <p>
      访问本网站的某些区域受到限制。我们保留在我们的自由裁量许可权制访问本网站（或实际上是整个网站）的区域的权利。
    </p>
    <p>
      如果NothingDB商务平台为您提供了用户id和密码以允许您访问本网站或其他内容或服务的受限区域，则必须确保用户id和密码保持机密。
    </p>
    <p>
      NothingDB商务平台可能会在我们的全权酌情权下禁用您的用户ID和密码，恕不另行通知或解释。
    </p>
    <h3>责任限制</h3>
    <p>
      我们对本网站的内容或使用或其他相关事宜不承担任何责任（无论是根据联系法、侵权法还是其他管道）：
    </p>
    <p>·任何直接损失；</p>
    <p>任何间接、特殊或间接损失；</p>
    <p>
      ·任何业务损失、收入损失、收入、利润或预期节馀、契约或业务关係损失、名誉或善意损失或资讯或数据的遗失或损坏。
    </p>
    <p>即使我们明确告知潜在损失，这些责任限制也适用。</p>
    <h3>异常</h3>
    <p>
      本网站免责声明将排除或限制法律暗示的任何保证，排除或限制它将是非法的；本网站免责声明将排除或限制我们在任何方面的责任：
    </p>
    <p>·因我们疏忽造成的死亡或人身伤害；</p>
    <p>·我们的欺诈或欺诈性失实陈述；</p>
    <p>·我们排除或限制、企图或意图排除或限制其责任的行为是非法的或非法的。</p>
    <h3>合理性</h3>
    <p>
      使用本网站即表示您同意本网站免责声明中规定的责任排除和限制是合理的。如果您认为他们不合理，您不得使用本网站。
    </p>
    <h3>其他缔约方</h3>
    <p>
      您同意，作为有限责任实体，我们有兴趣限制其官员和雇员的个人责任。您同意，您不会对我们的人员或员工就您在网站上遭受的任何损失提起任何索赔。
    </p>
    <p>
      您同意本网站免责声明中规定的担保和责任限制将保护我们的人员、员工、代理、子公司、继任者、分配人和分包商以及我们。
    </p>
    <h3>可执行性</h3>
    <p>
      如果本网站免责声明的任何条款，或被认为是不可执行的，根据适用法律，这将不会影响本网站免责声明的其他条款的可执行性。
    </p>
    <h3>赔偿</h3>
    <p>
      因违反本条款和条件的任何规定，所造成的NothingDB商务平台服务异常。本协定承诺并保留用户对我们任何损失、损害、成本、责任和费用（包括但不限于法律费用和我们向协力厂商支付的任何金额）的补偿责任。一切争议及索赔的解决以我们法律顾问的意见为准
    </p>
    <h3>违反这些条款和条件</h3>
    <p>
      在不损害本条款和条件下的其他权利的情况下，如果您以任何管道违反这些条款和条件，NothingDB商务平台可能採取我们认为适合处理违约的行为，包括暂停您访问本网站，禁止您访问本网站，阻止使用您的IP地址访问本网站的电脑，与您的互联网服务提供者联系，要求他们封锁您访问网站和/或提起法院诉讼。
    </p>
    <h3>变化</h3>
    <p>
      我们可能会不时修改这些条款和条件。修订后的条款和条件将适用于本网站在发佈修订条款和条件之日使用本网站。请定期查看此页面，以确保您熟悉当前版本。
    </p>
    <h3>整个协定</h3>
    <p>
      这些条款和条件构成您与我们之间关于您使用本网站的全部协定，并取代您使用本网站之前的所有协定。
    </p>
    <div class="footer">
      <p>
        &copy;<span>{{ this.host }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    host() {
      return window.location.host;
    },
  },
};
</script>
<style lang="less" scoped></style>
